import React from "react";
import { MENU_ITEM_ICON_DISABLED_COLOR } from "components/sideBar/sideBar";

interface IconProps {
  readonly isDisabled?: boolean;
}

export const PatientSurveyIcon: React.FC<IconProps> = ({ isDisabled }) => {
  return (
    <svg
      width="39px"
      height="36px"
      viewBox="0 0 39 36"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <desc>Created with sketchtool.</desc>
      <defs>
        <path
          d="M12,0 L12,0 C18.627417,-1.21743675e-15 24,5.372583 24,12 L24,12 C24,18.627417 18.627417,24 12,24 L12,24 C5.372583,24 8.11624501e-16,18.627417 0,12 L0,12 C-8.11624501e-16,5.372583 5.372583,1.21743675e-15 12,0 Z"
          id="path-1"
        ></path>
        <filter
          x="-54.2%"
          y="-45.8%"
          width="208.3%"
          height="208.3%"
          filterUnits="objectBoundingBox"
          id="filter-2"
        >
          <feOffset
            dx="0"
            dy="2"
            in="SourceAlpha"
            result="shadowOffsetOuter1"
          ></feOffset>
          <feGaussianBlur
            stdDeviation="4"
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
          ></feGaussianBlur>
          <feColorMatrix
            values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0"
            type="matrix"
            in="shadowBlurOuter1"
          ></feColorMatrix>
        </filter>
      </defs>
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="CareGEM-Provider-Global-navigation-V2.3"
          transform="translate(-14.000000, -471.000000)"
        >
          <g
            id="EducationTips-menu-Copy-3"
            transform="translate(14.000000, 471.000000)"
          >
            <g id="Tasks-icon" transform="translate(7.000000, 6.000000)">
              <g id="Rectangle-Copy-210">
                <use
                  fill="black"
                  fillOpacity="1"
                  filter="url(#filter-2)"
                  xlinkHref="#path-1"
                ></use>
                <use
                  fill={isDisabled ? MENU_ITEM_ICON_DISABLED_COLOR : "#208CFF"}
                  fillRule="evenodd"
                  xlinkHref="#path-1"
                ></use>
              </g>
              <path
                d="M8.41176471,7.41176471 L8.41176471,16.5882353 L15.4705882,16.5882353 L15.4705882,7.41176471 L8.41176471,7.41176471 Z M7,6 L16.8823529,6 L16.8823529,18 L7,18 L7,6 Z"
                id="Rectangle"
                fill="#FFFFFF"
                fillRule="nonzero"
              ></path>
              <g
                id="Group-8"
                transform="translate(9.117647, 10.941176)"
                stroke="#FFFFFF"
                strokeWidth="1.5"
              >
                <path
                  d="M1.64784563,2.50498338 L1.64784563,1.84321867 L0.986080928,2.50498338 L0.897845634,2.50498338 L0.941963281,2.54910102 L0.897845634,2.59321867 L0.986080928,2.59321867 L1.64784563,3.25498338 L1.64784563,2.59321867 L2.19486114,2.59321867 L2.19486114,3.25498338 L2.85662585,2.59321867 L2.94486114,2.59321867 L2.9007435,2.54910102 L2.94486114,2.50498338 L2.85662585,2.50498338 L2.19486114,1.84321867 L2.19486114,2.50498338 L1.64784563,2.50498338 Z"
                  id="Rectangle-Copy-10"
                  transform="translate(1.921353, 2.549101) rotate(-315.000000) translate(-1.921353, -2.549101) "
                ></path>
                <path
                  d="M2.14697983,2.29823522 L2.14697983,1.63647052 L1.48521513,2.29823522 L1.39697983,2.29823522 L1.44109748,2.34235287 L1.39697983,2.38647052 L1.48521513,2.38647052 L2.14697983,3.04823522 L2.14697983,2.38647052 L4.10576005,2.38647052 L4.10576005,3.04823522 L4.76752475,2.38647052 L4.85576005,2.38647052 L4.8116424,2.34235287 L4.85576005,2.29823522 L4.76752475,2.29823522 L4.10576005,1.63647052 L4.10576005,2.29823522 L2.14697983,2.29823522 Z"
                  id="Rectangle-Copy-11"
                  transform="translate(3.126370, 2.342353) rotate(-45.000000) translate(-3.126370, -2.342353) "
                ></path>
              </g>
              <rect
                id="Rectangle-Copy-2"
                stroke="#FFFFFF"
                strokeWidth="2"
                x="10.8235294"
                y="9.82352941"
                width="2.23529412"
                height="1"
              ></rect>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
